import { UnderHeader } from 'components/atoms/SectionWrapper.style';
import React from 'react';
import styled from 'styled-components';
import { HeadlineOne, Paragraph } from 'components/atoms/SectionWrapper.style';
import { cms } from 'assets/cms';

const FarmImg = styled.div`
  background: center center url(${cms.elgreen.idea});
  background-size: cover;
  height: 250px;
  background-repeat: no-repeat;
  color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media ${({ theme }) => theme.media.tablet} {
    height: 350px;
  }
  padding: 35px;
`;
const Par = styled.div`
  font-size: 8px;
  right: 0;
`;

const OfferImages = () => (
  <>
    <UnderHeader />
    <FarmImg>
      {/* <Paragraph>Receco</Paragraph> */}
      {/* <HeadlineOne>Oferta</HeadlineOne> */}
    </FarmImg>
    {/* <Par>
      <a href="https://www.freepik.com/free-photo/eco-concept-light-bulb-grow-grass_1010173.htm#page=2&query=solar%20panel&position=34&from_view=search">
        Image by jannoon028
      </a>{' '}
      on Freepik
    </Par> */}
  </>
);

export default OfferImages;
